import React, { useState } from "react";

const TextAreaComponent = ({
  rows = 3,
  name = "",
  value = "",
  error = false,
  showResizer = false,
  onChange = () => {},
  placeholder = "Enter your text here...",
  className = "",
}) => {
  const [isInputFocused, setIsInputFocused] = useState(false);

  return (
    <div className="w-full">
      <textarea
        id={name}
        name={name}
        rows={rows}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        onFocus={() => setIsInputFocused(true)}
        onBlur={() => setIsInputFocused(false)}
        className={`w-full border rounded-md p-2 thinscrollbar text-[#292E33] ${!showResizer && "resize-none"}
            focus:outline-none focus:ring-0 ring-0
            placeholder:text-[#AFAFAF]  font-poppins
            ${error ? "border-[#EF4444] focus:ring-[#EF4444] focus:border-[#EF4444]" : isInputFocused ? "border-[#7A7D84] focus:ring-[#7A7D84] focus:border-[#7A7D84]" : "border-[#DFE2E5] focus:ring-0"}  
            ${className}`}
      />
    </div>
  );
};

export default TextAreaComponent;
